<script lang="ts">
  export let size: number = 40;
</script>

<svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    opacity="0.14"
    d="M35.6333 14.3002V25.7002C35.6333 27.5668 34.6332 29.3002 33.0166 30.2502L23.1166 35.9669C21.4999 36.9002 19.4999 36.9002 17.8665 35.9669L7.96653 30.2502C6.34987 29.3169 5.34985 27.5835 5.34985 25.7002V14.3002C5.34985 12.4336 6.34987 10.7002 7.96653 9.75015L17.8665 4.0335C19.4832 3.10016 21.4832 3.10016 23.1166 4.0335L33.0166 9.75015C34.6332 10.7002 35.6333 12.4169 35.6333 14.3002Z"
    class={$$props.class || "fill-brand-green"}
  />
  <path
    d="M20.5 22.9165C19.8167 22.9165 19.25 22.3498 19.25 21.6665V12.9165C19.25 12.2332 19.8167 11.6665 20.5 11.6665C21.1833 11.6665 21.75 12.2332 21.75 12.9165V21.6665C21.75 22.3498 21.1833 22.9165 20.5 22.9165Z"
    class={$$props.class || "fill-brand-green"}
  />
  <path
    d="M20.4999 28.7499C20.2833 28.7499 20.0666 28.6999 19.8666 28.6166C19.6499 28.5332 19.4832 28.4166 19.3165 28.2666C19.1665 28.1 19.0499 27.9166 18.9499 27.7166C18.8666 27.5166 18.8333 27.2999 18.8333 27.0833C18.8333 26.6499 18.9999 26.2166 19.3165 25.8999C19.4832 25.7499 19.6499 25.6333 19.8666 25.55C20.4832 25.2833 21.2166 25.4332 21.6833 25.8999C21.8333 26.0666 21.9499 26.2333 22.0332 26.4499C22.1166 26.6499 22.1666 26.8666 22.1666 27.0833C22.1666 27.2999 22.1166 27.5166 22.0332 27.7166C21.9499 27.9166 21.8333 28.1 21.6833 28.2666C21.3666 28.5833 20.9499 28.7499 20.4999 28.7499Z"
    class={$$props.class || "fill-brand-green"}
  />
</svg>
